module.exports = __webpack_public_path__ + "img/ico_weed.ba81d925.svg";